/// <amd-module name="TFS/Admin/Views/GitHubConnection/Models" />

export interface IGitHubConnectionProps {}
